<template>
  <div class="page-categories page-fakro">
    <a href="#" v-scroll-to="'#header'" id="go-top">
      <font-awesome-icon icon="chevron-up" class="fas"></font-awesome-icon>
      <span>Sus</span>
    </a>
    <a href="/" id="go-back">
      <font-awesome-icon icon="chevron-left" class="fas"></font-awesome-icon>
      <span>Inapoi</span>
    </a>
    <transition name="fade">
      <div id="loading" v-if="loading">
        <img src="/src/assets/img/loader.gif" alt="Loading" />
      </div>
    </transition>
    <transition name="fade">
      <div class="container" v-if="!loading">
        <div class="row">
          <div class="col-lg-3">
            <aside id="aside">
              <div class="aside-header">
                <a href="/" title="Intoarce-te la pagina principala">
                  <font-awesome-icon icon="arrow-left" class="fas"></font-awesome-icon>
                </a>
                <h3>Produse</h3>
                <img src="/src/assets/img/fakro-logo.gif" alt="Fakro" />
              </div>
              <fakroAside />
            </aside>
          </div>
          <div class="col-lg-9">
            <main class="main-content">
              <fakroProducts />
            </main>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import fakroAside from "../../components/layouts/fakroAside.vue";
import fakroProducts from "../../components/layouts/fakroProducts.vue";

export default {
  data() {
    return {
      name: "Fakro",
      products: [],
      loading: false
    };
  },
  components: {
    fakroAside,
    fakroProducts
  },
  created() {
    let self = this;
    self.loading = true;
    self.$http.get("/data/fakro-categories.json").then(function(data) {
      self.loading = false;
      self.products = data.body;
    });
  }
};
</script>
<style lang="scss">
@media (max-width: 991.98px) {
  .page-categories .container {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Fakro.vue